<mat-toolbar color="accent">Amend Account Credit</mat-toolbar>

<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-dialog-content fxLayout="column" fxLayoutGap="16px">
    <mat-form-field *prHasPermission="[accountAdminPermission]" fxFlex>
      <mat-label>Date Received</mat-label>
      <input
        matInput
        formControlName="dateReceived"
        [matDatepicker]="dateReceived"
        [min]="minDate$ | async"
        [max]="amendDateStore.maxDate$ | async"
        (focus)="dateReceived.open()"
        (click)="dateReceived.open()"
      />
      <mat-datepicker-toggle matIconSuffix [for]="dateReceived" />
      <mat-datepicker #dateReceived />
    </mat-form-field>

    @if (showAttributedTo) {
      <pr-attributed-to-selector
        *prHasPermission="[accountAdminPermission]"
        class="flex grow"
        formControlName="attributedTo"
        [staff]="staff"
      />
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="primary" [disabled]="form.invalid">
      Submit
    </button>
  </mat-dialog-actions>
</form>
